/**
 * Session keys cleared on impersonation start/end — mirrors Angular `AuthService.resetAllListFilter`.
 */
export const IMPERSONATION_SESSION_FILTER_KEYS = [
  'message_filter',
  'propertystafflist_filter',
  'applicationlist_filter',
  'residentlist_filter',
  'defaultlist_filter',
  'propertylist_filter',
  'companylist_filter',
  'agencylist_filter',
  'housinglist_filter',
  'non_verified_property_filter',
  'pmcperformancereport_filter',
  'orglist_filter',
  'invitereportlist_filter',
  'yardiinvitelist_filter',
  'agentlist_filter',
  'templatelist_filter',
  'imapmaillog_filter',
  'cronlist_filter',
  'userlist_filter',
  'productlist_filter',
  'apilogs_filter',
  'maillog_filter',
  'mailtrap_filter',
  'pending_defaults_filter',
  'approved_not_purchased_filter',
  'daily_application_filter',
  'charityresidentlist_filter',
  'mailgunlog_filter',
  'paymentlogs_filter',
  'financialdailylogs_filter',
  'financiallogs_filter',
  'missingcontacts_filter',
  'activepropnoapps_filter',
  'lossratio_filter',
  'paidnotpaid_filter',
  'claimnottimely_filter',
] as const

export function clearImpersonationSessionFilters(): void {
  try {
    IMPERSONATION_SESSION_FILTER_KEYS.forEach((key) => sessionStorage.removeItem(key))
  } catch {
    /* ignore */
  }
}
